<template>
	<div class="contents-body" :class="classes">

		<transition v-on:before-enter="whenLoading" v-on:after-enter="afterLoading" appear name="fade" mode="out-in">
			<router-view/>
		</transition>
	</div>
</template>

<script>
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';
import loadingOverlay from '@arena/toolkit/src/components/common/loading-overlay';

export default {
	name: 'app',
	components: {
		loadingOverlay,
		svgIcon,
	},
	metaInfo() {
		return {
			title: this.$t('wallet.title'),
			meta: [
				{ name: 'description', content: this.$t('wallet.meta-desc') },
				{ name: 'keywords', content: this.$t('wallet.meta-keyword') },
				{ property: 'og:site_name', content: this.$t('wallet.title') },
				{ property: 'og:type', content: 'website' },
				{ property: 'og:url', content: 'http://www.nexon.com/' },
				{ property: 'og:title', content: this.$t('wallet.title') },
				{ property: 'og:description', content: this.$t('wallet.meta-desc') },
				{ property: 'og:image', content: 'https://web.nxfs.nexon.com/nexon-logo.png' },
				{ itemprop: 'name', content: this.$t('wallet.meta-title') },
				{ itemprop: 'description', content: this.$t('wallet.meta-desc') },
				{ itemprop: 'image', content: 'https://web.nxfs.nexon.com/nexon-logo.png' },
				{
					'http-equiv': 'Content-Security-Policy',
					content: `default-src *.nexon.com *.nexon.io *.nexon.net *.google-analytics.com 'self';
						connect-src *.nexon.com *.nexon.net *.nexon.io *.serving-sys.com *.google-analytics.com 'self';
						script-src *.nexon.com *.nexon.net *.google-analytics.com *.googletagmanager.com *.google.com *.facebook.net *.gstatic.com *.iesnare.com *.googleadservices.com *.doubleclick.net https://sentry.d.nexon.io *.serving-sys.com  https://gleam.io 'unsafe-eval' 'unsafe-inline' 'self';
						style-src *.nexon.com *.google.com *.googleapis.com 'unsafe-inline';
						img-src *.nexon.com *.google.com *.google-analytics.com https://www.googletagmanager.com *.gstatic.com *.doubleclick.net 'self' data:;
						font-src *.nexon.com *.google.com *.facebook.com 'self';
						frame-src *.nexon.com *.nexon.net *.google.com *.facebook.com`,
				},
			]
		};
	},
	computed: {
		classes() {
			return [
				this.region,
				this.language,
				this.channel,
				`product-${this.productId}`,
			];
		},
		region() {
			return environment.region;
		},
		language() {
			return this.$i18n.locale;
		},
		isMobile() {
			return this.$store.state.isMobile ? 'mobile' : '';
		},
		isLauncher() {
			return navigator.userAgent.indexOf('NexonLauncher') > 0;
		},
		isGame() {
			return this.$store.state.appType === 'game';
		},
		productId() {
			const prodId = this.$cookie.get('CommerceProdId');
			return prodId;
		},
		channel() {
			if (this.isGame) return 'game';
			if (this.isLauncher) return 'launcher';
			if (this.isMobile) return 'mobile';
			return 'web';
		},
	},
	methods: {
		whenLoading() {
			const mainSpinner = document.getElementById('main-spinner');
			if (!mainSpinner.classList.contains('hide')) {
				mainSpinner.className += ' hide';
			}
			this.$store.commit('startLoadingOverlay', this.$t('wallet.loading-wallet'));
			this.$eventBus.$emit('show-loading-overlay');
		},
		afterLoading() {
			this.$eventBus.$emit('hide-loading-overlay');
		},
		storeChannel() {
			this.$store.commit('setAppType', this.channel);
			document.body.className = this.channel;
		},
	},
	mounted() {
		this.storeChannel();
		window.version = `Current Version => ${VERSION}`;
		this.$store.commit('startLoadingOverlay', this.$t('loading-wallet'));
	},
	updated() {
		dataLayer.push({
			channel: this.channel,
			region: this.region,
			language: this.$i18n.locale
		});
	}
};
</script>

<style lang="less">
	@import "~@arena/toolkit/src/less/toolkit/toolkit.less";
	@import "./less/global";
	@import "./less/responsive";
</style>



// WEBPACK FOOTER //
// src/App.vue